<pp-modal>
  <ng-container heading>
    {{ 'Delete' | ppTranslate }}
    <strong>{{ field.label }}</strong>
    {{ 'field' | ppTranslate }}
  </ng-container>

  <ng-container body>
    @if (field.type === ECustomFieldType.FORMULA) {
      <div class="warningMessage__expanded">
        <header class="warningMessage__expanded--header">
          {{ 'formula_delete_warning_header' | ppTranslate }}
        </header>
        {{ 'formula_delete_warning' | ppTranslate }}
      </div>
    }

    @if (field.type !== ECustomFieldType.FORMULA) {
      <p class="no-margin word-break">
        {{ 'delete_warning' | ppTranslate }}
        <strong>{{ field.label }}</strong>
        {{ 'field' | ppTranslate }}?
      </p>
    }
  </ng-container>

  <ng-container footer>
    <pp-modal-generic-footer
      [ppConfirmText]="'Delete' | ppTranslate"
      [ppProcess]="processing"
      (ppCancel)="hideModal()"
      (ppConfirm)="delete()"
      [ppError]="true"
    ></pp-modal-generic-footer>
  </ng-container>
</pp-modal>
